enum Region {
	EUROPE = 'EUROPE',
	UNITED_STATES = 'UNITED_STATES',
	UNITED_KINGDOM = 'UNITED_KINGDOM',
	GERMANY = 'GERMANY',
	BULGARIA = 'BULGARIA',
	ITALY = 'ITALY',
	FRANCE = 'FRANCE',
	NETHERLANDS = 'NETHERLANDS',
	POLAND = 'POLAND',
	ROMANIA = 'ROMANIA',
	SERBIA = 'SERBIA',
	SWITZERLAND = 'SWITZERLAND',
	AUSTRIA = 'AUSTRIA',
	ISRAEL = 'ISRAEL',
	ALBANIA = 'ALBANIA',
	CZECH_REPUBLIC = 'CZECH_REPUBLIC',
	CANADA = 'CANADA',
	AUSTRALIA = 'AUSTRALIA',
	SINGAPORE = 'SINGAPORE',
	TURKEY = 'TURKEY',
	GREECE = 'GREECE',
}

export const metaradarEnabledRegions = [
	Region.UNITED_STATES,
	Region.UNITED_KINGDOM,
	Region.AUSTRALIA,
	Region.GERMANY,
	Region.GREECE,
	Region.ISRAEL,
	Region.ITALY,
	Region.SINGAPORE,
	Region.SWITZERLAND,
	Region.TURKEY
]

export const marketStateEnabledRegions = [
	Region.EUROPE,
	Region.UNITED_STATES,
	Region.UNITED_KINGDOM,
	Region.AUSTRALIA,
	Region.CANADA,
	Region.GREECE,
	Region.ISRAEL,
	Region.SWITZERLAND,
	Region.SINGAPORE,
	Region.TURKEY,
]

export default Region;